import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-manage-notifications',
  templateUrl: './manage-notifications.component.html',
  styleUrls: ['./manage-notifications.component.scss'],
})
export class ManageNotificationsComponent implements OnInit {

  public infoForm: FormGroup;

  public sendEmailUponLogin: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;

  public emailUponLogin: boolean = false;
  public allowPromoSmsCheck: boolean = false;
  public allowPromoEmailsCheck: boolean = false;

  public error: any = null;

  constructor(
    public authService: AuthenticationService,
    private userSession: UserSessionService,
    private successMessageService: SuccessMessageService
  ) {

    this.successMessageService.clearMessage();
    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.emailUponLogin = customer.sendEmailUponLogin;
        this.allowPromoEmailsCheck = customer.allowPromoEmails;
        this.allowPromoSmsCheck = customer.allowPromoSms;
      }
    });

    this.userSession.refreshCustomer();
  }

  ngOnInit() {
    this.infoForm = new FormGroup({
      sendEmailUponLogin: new FormControl(""),
      allowPromoSms: new FormControl(""),
      allowPromoEmails: new FormControl(""),
    });

    this.sendEmailUponLogin = this.infoForm.get("sendEmailUponLogin");
    this.allowPromoSms = this.infoForm.get("allowPromoSms");
    this.allowPromoEmails = this.infoForm.get("allowPromoEmails");
  }

  onSubmit() {

    this.infoForm.get("sendEmailUponLogin").setValue(this.emailUponLogin ? 1 : 0);
    this.infoForm.get("allowPromoSms").setValue(this.allowPromoSmsCheck ? 1 : 0);
    this.infoForm.get("allowPromoEmails").setValue(this.allowPromoEmailsCheck ? 1 : 0);

    this.authService.callUpdatePromotionPreferences(this.infoForm.value).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.userSession.refreshCustomer();
          this.successMessageService.setMessage('Your account has been updated!');
          this.error = null;
        }
      },
      (error) => {
        console.error("callUpdateAccount ", error);

        switch (error.getErrorCode().toUpperCase()) {
          case "BAD_CONTENT":
            error.setErrorMessage(error.getErrorMessage());
            break;
          default:
            error.setErrorMessage(error.getErrorMessage());
            break;
        }
        this.successMessageService.clearMessage();  //SuccessMessage is not yet implemented. Needs to be added later
        this.error = error;
      }
    );
  }
}
